module.exports = __webpack_public_path__ + "img/p014.2cd6389f.jpg";